<template>
  <main class="main" v-if="publication">
    <div class="page-title">
      <span v-if="publication.category !== 'Other'" class="indent" v-html="publication.num" />{{ publication.title }}
    </div>
    <gallery :images="publication.images" :document="publication.document" :border="true" />
    <div class="page-text" v-html="publication.text" />
    <div class="page-text">
      <a
        v-for="file in publication.document"
        :key="file.url"
        :href="file.url"
        target="_blank"
      >
        {{ file.caption }}
      </a>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import Gallery from "@/components/Gallery.vue";
export default {
  name: "publication",
  metaInfo() {
    return {
      title: "- " + this.publication.title,
    };
  },
    components: {
        Gallery,
    },
  computed: mapState(["publication"]),
};
</script>

<style lang="scss" scoped>
@import "../assets/css/defaults.scss";

.indent {
  width: 5rem;
  display: inline-block;
  @media only screen and (max-width: 768px) {
    width: 7rem;
  }
}
.page-title {
  margin-bottom: calc(var(--gap) / 6);
}
.larkin-gallery {
  position: relative;
  display: block;
  width: 100%;
  height: 67%;
  margin-bottom: calc(var(--gap) * 3);
&::-webkit-scrollbar {
    display: none;
}
@media only screen and (max-width: 768px) {
        margin-bottom: calc(var(--gap) * 6);
        overflow-x: auto;
        overflow-y: auto;
        display: flex;
        scroll-snap-type: x mandatory;
        margin-bottom: calc(var(--gap) * 6);
  }
  &.next {
    .larkin-slide {
      img {
        cursor: e-resize;
      }
    }
  }
  &.prev {
    .larkin-slide {
      img {
        cursor: w-resize;
      }
    }
  }
  .larkin-slide {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin-right: var(--gap);
    position: absolute;
    display: none;
    @media only screen and (max-width: 768px) {
        position: relative;
        flex:0 0 auto;
        scroll-snap-align: start;
        display: block;
    }
    &.active {
    //   display: flex;
    //   flex-wrap: wrap;
    //   justify-content: flex-start;
    }
    img {
      width: auto;
      object-fit: contain;
      object-position: center;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -o-user-select: none;
      user-select: none;
      border:0.65pt solid black;
    }
    .slide-info {
      margin-top: calc((var(--line-height) * var(--font-size)) / 6);
      font-size: calc(var(--font-size) / 1.75);
      margin-bottom: var(--gap);
      width: 100%;
      .slide-caption {
        display: inline-block;
        width: 75%;
      }
      .slide-counter {
        display: inline-block;
        text-align: right;
        width: 25%;
        vertical-align: top;
        .slide-counter-index {
            display: inline-block;
            width:6ch;
        }
      }
    }
  }
}
</style>
